import React from 'react';
import { AppSkeletonImage } from '../../../common/ui/AppSkeletonImage.tsx';
import imgSVG from './assets/project-summary-skeleton.tpl.svg';

export const ProjectSummarySkeleton = () => <AppSkeletonImage src={imgSVG} />;
